import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import './PaymentButton.scss';

import StripeButton from './StripeButton';
import BraintreePaypalButton from './BraintreePaypalButton';
import PaidForButton from './PaidForButton';
import PaypalCheckoutButton from './PaypalCheckoutButton';

import Loading from '../../Loading';

const PaymentButton = props => {
  const order = get(props, 'order', {});
  const total = get(order, 'totals_v2.order.formatted', order.totals.order.formatted);
  let PaymentButton = null;

  if (props.method === 'stripe') {
    PaymentButton = (
      <StripeButton {...props} total={total} />
    );
  }

  if (props.method === 'paypal') {
    PaymentButton = (
      <BraintreePaypalButton {...props} />
    );
  }

  if (props.method === 'paypal_checkout') {
    PaymentButton = (
      <PaypalCheckoutButton  {...props} />
    );
  }

  if (props.method === 'free') {
    PaymentButton = (
      <PaidForButton {...props} />
    );
  }

  return (
    <div className="payment-buttons">
      {props.method === props.submittingMethod &&
        <Loading absolute xsmall dark fade />
      }
      {PaymentButton}
    </div>
  );
};

PaymentButton.propTypes = {
  method: PropTypes.string.isRequired,
  submittingMethod: PropTypes.string,
  setSubmittingMethod: PropTypes.func.isRequired,
  cta: PropTypes.string,
  order: PropTypes.object,
  settings: PropTypes.object
};

export default PaymentButton;



// WEBPACK FOOTER //
// ./src/client/js/view/components/PaymentMethods/PaymentButton/PaymentButton.js